<template>
    <div>
        <mBanner></mBanner>
        <yindao></yindao>
        <mBeian></mBeian>
    </div>
</template>
<script>
import mBanner from '@/components/m/mBanner.vue'
import mBeian from '@/components/m/mBeian'
import  yindao  from    './components/yindao.vue'

export default {
    components: {
        mBanner,
        mBeian,
        yindao
    },
    created(){
        this.$redirectByDevice()            //pc/移动端自动跳转
    }
}
</script>
<style lang="less" scoped>

</style>